import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOrigin = (props) => /* @__PURE__ */ _jsxs("svg", {
	height: 43,
	viewBox: "0 0 36 43",
	width: 36,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 18,
			cy: 18,
			fill: "#009fe3",
			r: 18
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m-10.465-5.43a1.536 1.536 0 0 0 -.29-.235 2.9 2.9 0 0 0 -.445-.235 3.244 3.244 0 0 0 -.56-.18 2.785 2.785 0 0 0 -.625-.07 1.7 1.7 0 0 0 -1.045.26.86.86 0 0 0 -.335.72.78.78 0 0 0 .105.425.9.9 0 0 0 .325.29 2.547 2.547 0 0 0 .55.22q.33.1.77.205a8.8 8.8 0 0 1 .975.29 2.775 2.775 0 0 1 .735.39 1.587 1.587 0 0 1 .465.565 1.831 1.831 0 0 1 .165.815 1.974 1.974 0 0 1 -.2.93 1.746 1.746 0 0 1 -.56.635 2.472 2.472 0 0 1 -.825.36 4.241 4.241 0 0 1 -1.01.115 5.039 5.039 0 0 1 -1.57-.245 4.486 4.486 0 0 1 -1.36-.715l.51-.96a2.384 2.384 0 0 0 .375.29 3.492 3.492 0 0 0 .57.3 5 5 0 0 0 .7.23 3.245 3.245 0 0 0 .79.1 1.9 1.9 0 0 0 1.02-.23.755.755 0 0 0 .36-.68.729.729 0 0 0 -.135-.45 1.159 1.159 0 0 0 -.385-.315 3.357 3.357 0 0 0 -.61-.245q-.36-.11-.82-.23a8.494 8.494 0 0 1 -.925-.3 2.315 2.315 0 0 1 -.655-.375 1.472 1.472 0 0 1 -.395-.515 1.711 1.711 0 0 1 -.135-.715 2.062 2.062 0 0 1 .2-.925 1.977 1.977 0 0 1 .545-.68 2.383 2.383 0 0 1 .815-.415 3.559 3.559 0 0 1 1.02-.14 3.74 3.74 0 0 1 1.33.23 4.4 4.4 0 0 1 1.07.57zm7.07-.68h-2.36v6.11h-1.13v-6.11h-2.37v-.99h5.855zm2.34-.99h.98l2.8 7.1h-1.18l-.745-1.93h-2.74l-.745 1.93h-1.19zm1.63 4.34-1.14-3.05-1.18 3.05zm3.03 2.76v-7.1h3.095a1.971 1.971 0 0 1 .885.2 2.265 2.265 0 0 1 .695.525 2.475 2.475 0 0 1 .455.74 2.269 2.269 0 0 1 .165.845 2.366 2.366 0 0 1 -.1.69 2.419 2.419 0 0 1 -.28.61 1.969 1.969 0 0 1 -.44.485 1.813 1.813 0 0 1 -.57.305l1.665 2.7h-1.27l-1.54-2.47h-1.64v2.47zm1.12-3.46h1.96a.9.9 0 0 0 .435-.105 1.029 1.029 0 0 0 .335-.29 1.467 1.467 0 0 0 .22-.425 1.6 1.6 0 0 0 .08-.51 1.373 1.373 0 0 0 -.095-.51 1.462 1.462 0 0 0 -.25-.42 1.185 1.185 0 0 0 -.36-.285.921.921 0 0 0 -.425-.105h-1.9zm10.59-2.65h-2.36v6.11h-1.13v-6.11h-2.37v-.99h5.86z",
			fill: "#fff",
			transform: "translate(18 22)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m7.5 0 7.5 13h-15z",
			fill: "#009fe3",
			transform: "matrix(-1 0 0 -1 26 43)"
		})
	]
});
export default SvgOrigin;
